import * as React from "react";

import {
  AnalyticsConfigurationProvider,
  AnalyticsProvider,
  createAnalyticsContext,
} from "../../../Common";

import { useReactPlpInitialState } from "../react-plp-intial-state-provider";

import { ReactPlpAnalyticsInterface } from "./analytics-interface";
import { useAnalyticsXO } from "./analytics-xo";
import { useAnalyticsGtm } from "./analytics-gtm";
import { useAnalyticsTripleWhale } from "./analytics-triplewhale";

export const [analyticsContext, usePlpAnalytics] =
  createAnalyticsContext<ReactPlpAnalyticsInterface>();

const PlpAnalyticsProvider_Implementations: React.FunctionComponent = (
  props
) => {
  const analyticsXO = useAnalyticsXO();
  const analyticsGtm = useAnalyticsGtm();
  const analyticsTripleWhale = useAnalyticsTripleWhale();

  const implementations = React.useMemo(
    () => [analyticsXO, analyticsGtm, analyticsTripleWhale],
    [analyticsXO, analyticsGtm, analyticsTripleWhale]
  );

  return (
    <AnalyticsProvider
      context={analyticsContext}
      implementations={implementations}
    >
      {props?.children || []}
    </AnalyticsProvider>
  );
};

export const PlpAnalyticsProvider: React.FunctionComponent = (props) => {
  return (
    <AnalyticsConfigurationProvider useInitialState={useReactPlpInitialState}>
      <PlpAnalyticsProvider_Implementations>
        {props.children || []}
      </PlpAnalyticsProvider_Implementations>
    </AnalyticsConfigurationProvider>
  );
};
